export const stringsKey = "USSDScriptDialog";
export const englishStrings = {
	scriptDialogHeader: "USSD Script",
	downloadButton: "Download",
	copyToClipboardButton: "Copy To Clipboard",
	copyToClipboardMessage: "Content copied to clipboard!",
};
